import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem, TabButton } from './subcomponents';
const Tab = ({ handleTabClick, isActive = false, label, index, className, id, forwardRef }) => {
    return (_jsx(ListItem, Object.assign({ showActiveStyles: isActive, className: className, role: "presentation", onClick: () => {
            handleTabClick(index);
        } }, { children: _jsx(TabButton, Object.assign({ role: "tab", id: id, ref: forwardRef, tabIndex: isActive ? 0 : -1, "aria-selected": isActive, "aria-controls": `${id}-content`, showActiveStyles: isActive }, { children: label })) })));
};
export default Tab;
